import { defineAction } from '@cheesecakelabs/boilerplate/utils'

import * as collaborationService from '_services/collaboration'

export const GET_COLLABORATORS = defineAction('GET_COLLABORATORS')
export const GET_INVITES_SENT = defineAction('GET_INVITES_SENT')
export const GET_INVITES_RECEIVED = defineAction('GET_INVITES_RECEIVED')
export const SEND_COLLAB_INVITE = defineAction('SEND_COLLAB_INVITE')
export const ACCEPT_COLLAB_INVITE = defineAction('ACCEPT_COLLAB_INVITE')
export const IGNORE_COLLAB_INVITE = defineAction('IGNORE_COLLAB_INVITE')
export const DELETE_COLLAB_INVITE = defineAction('DELETE_COLLAB_INVITE')
export const REMIND_COLLAB_INVITE = defineAction('REMIND_COLLAB_INVITE')
export const DELETE_COLLAB = defineAction('DELETE_COLLAB')
export const CREATE_COLLAB_NOTE = defineAction('CREATE_COLLAB_NOTE')
export const GET_NOTES_RECEIVED = defineAction('GET_NOTES_RECEIVED')
export const GET_NOTES_SENT = defineAction('GET_NOTES_SENT')
export const UPDATE_COLLAB_NOTE = defineAction('UPDATE_COLLAB_NOTE')
export const DELETE_COLLAB_NOTE = defineAction('DELETE_COLLAB_NOTE')
export const ARCHIVE_COLLAB_NOTE = defineAction('ARCHIVE_COLLAB_NOTE')
export const READ_COLLAB_NOTE = defineAction('READ_COLLAB_NOTE')
export const CLOSE_COLLAB_NOTE = defineAction('CLOSE_COLLAB_NOTE')

export const getCollaborators = () => (dispatch, getState) =>
  dispatch({
    type: GET_COLLABORATORS.ACTION,
    payload: collaborationService.getCollaborators(getState().user.get('token')),
  })

export const getInvitesSent = () => (dispatch, getState) =>
  dispatch({
    type: GET_INVITES_SENT.ACTION,
    payload: collaborationService.listInvitesSent(getState().user.get('token')),
  })

export const getInvitesReceived = () => (dispatch, getState) =>
  dispatch({
    type: GET_INVITES_RECEIVED.ACTION,
    payload: collaborationService.listInvitesReceived(getState().user.get('token')),
  })

export const sendCollabInvite = payload => (dispatch, getState) =>
  dispatch({
    type: SEND_COLLAB_INVITE.ACTION,
    payload: collaborationService
      .sendInvite(getState().user.get('token'))(payload)
      .then(() => collaborationService.listInvitesSent(getState().user.get('token'))),
  })

export const ignoreCollabInvite = payload => (dispatch, getState) =>
  dispatch({
    type: IGNORE_COLLAB_INVITE.ACTION,
    payload: collaborationService
      .ignoreInvite(getState().user.get('token'))(payload)
      .then(() => payload),
  })

export const acceptCollabInvite = payload => (dispatch, getState) =>
  dispatch({
    type: ACCEPT_COLLAB_INVITE.ACTION,
    payload: collaborationService
      .acceptInvite(getState().user.get('token'))(payload)
      .then(() => payload),
  })

export const removeCollabInvite = payload => (dispatch, getState) =>
  dispatch({
    type: DELETE_COLLAB_INVITE.ACTION,
    payload: collaborationService
      .deleteInvite(getState().user.get('token'))(payload)
      .then(() => collaborationService.listInvitesSent(getState().user.get('token'))),
  })

export const remindCollabInvite = payload => (dispatch, getState) =>
  dispatch({
    type: REMIND_COLLAB_INVITE.ACTION,
    payload: collaborationService.remindInvite(getState().user.get('token'))(payload),
  })

export const removeCollab = payload => (dispatch, getState) =>
  dispatch({
    type: DELETE_COLLAB.ACTION,
    payload: collaborationService
      .removeCollab(getState().user.get('token'))(payload)
      .then(() => collaborationService.getCollaborators(getState().user.get('token'))),
  })

export const createCollabNote = payload => (dispatch, getState) =>
  dispatch({
    type: CREATE_COLLAB_NOTE.ACTION,
    payload: collaborationService
      .createNote(getState().user.get('token'))(payload)
      .then(() => collaborationService.getNotesSent(getState().user.get('token'))),
  })

export const getNotesReceived = () => (dispatch, getState) =>
  dispatch({
    type: GET_NOTES_RECEIVED.ACTION,
    payload: collaborationService.getNotesReceived(getState().user.get('token')),
  })

export const getNotesSent = () => (dispatch, getState) =>
  dispatch({
    type: GET_NOTES_SENT.ACTION,
    payload: collaborationService.getNotesSent(getState().user.get('token')),
  })

export const updateCollabNote = payload => (dispatch, getState) =>
  dispatch({
    type: UPDATE_COLLAB_NOTE.ACTION,
    payload: collaborationService
      .updateNote(getState().user.get('token'))(payload)
      .then(() => collaborationService.getNotesSent(getState().user.get('token'))),
  })

export const deleteCollabNote = payload => (dispatch, getState) =>
  dispatch({
    type: DELETE_COLLAB_NOTE.ACTION,
    payload: collaborationService
      .deleteNote(getState().user.get('token'))(payload)
      .then(() => collaborationService.getNotesSent(getState().user.get('token'))),
  })

export const archiveCollabNote = payload => (dispatch, getState) =>
  dispatch({
    type: ARCHIVE_COLLAB_NOTE.ACTION,
    payload: collaborationService
      .archiveNote(getState().user.get('token'))(payload)
      .then(() => collaborationService.getNotesSent(getState().user.get('token'))),
  })

export const readCollabNote = payload => (dispatch, getState) =>
  dispatch({
    type: READ_COLLAB_NOTE.ACTION,
    payload: collaborationService
      .readNote(getState().user.get('token'))(payload)
      .then(() => collaborationService.getNotesReceived(getState().user.get('token'))),
  })

export const closeCollabNote = payload => (dispatch, getState) =>
  dispatch({
    type: CLOSE_COLLAB_NOTE.ACTION,
    payload: collaborationService
      .closeNote(getState().user.get('token'))(payload)
      .then(() => collaborationService.getNotesReceived(getState().user.get('token'))),
  })



// WEBPACK FOOTER //
// ./src/modules/collaboration/actions.js